<template>
    <div class="loginbg" style="display: none;" id="login-main-hr">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <div class="form-group">
                                <label for="username">Username / Dayforce Id</label>
                                <input v-model="username" type="text" name="username" class="form-control" id="username_login" placeholder="Enter Username / Dayforce Id">
                                <span class="help is-danger">{{username_error_msg}}</span>
                            </div>

                            <div class="form-group">
                                <label for="password">Password</label>
                                <div style="position:relative">
                                    <template v-if="isPasswordHide">
                                        <input v-model="password" type="password" name="password" class="form-control" id="password_login" placeholder="Enter password">
                                    </template>
                                    <template v-else>
                                        <input v-model="password" type="text" name="password" class="form-control" id="password_login" placeholder="Enter password">
                                    </template>
                                    <a v-on:click.prevent="hideShowPassword()">
                                        <template v-if="isPasswordHide">
                                            <i class="fa fa-eye" style="position:absolute;top:10px;right:12px;" ></i>
                                        </template>
                                        <template v-else>
                                            <i class="fa fa-eye-slash" style="position:absolute;top:10px;right:12px;" ></i>
                                        </template>
                                    </a>
                                </div>
                                <span class="help is-danger">{{password_error_msg}}</span>
                            </div>
                          <span class="help is-danger">{{error_msg_login}}</span>

                            <!-- <div class="form-check not-registered">
                                <input type="checkbox">
                                <span class="checkbox-placeholder"></span>
                                Remember me
                                <a :href="not_registered_url" target="_blank" style="float: right">Not Registered?</a>
                            </div> -->
                            <div>
                                <button :disabled="disableButtons.loginButton" id="loginbtn" type="submit" class="btn btn-primary" v-on:click.prevent="login(this)">{{buttonNames.loginButton}}</button>
                                <template v-if="isNonVVGDealer == 'NO'">
                                    <a :href="forgot_pass_url" target="_blank" style="float: right">Forgot password?</a>
                                </template>
                                <template v-else>
                                    <router-link style="float: right;" v-bind:to="{name: 'UserForgotPassword'}"> Forgot password?</router-link>
                                </template>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from 'vue';
    import {HTTP} from '../../http-common';
    import EventBus from '.././event-bus';
    var self;

    export default {
        name: 'Login',
        data() {
            return {
                username: "",
                password: "",
                not_registered_url: "",
                forgot_pass_url: "",
                error_msg_login: "",
                username_error_msg: "",
                password_error_msg: "",

                forgot_pass_url: "",

                buttonNames : {
                    loginButton : 'Login',
                },

                disableButtons : {
                    loginButton : false,
                },
                isNonVVGDealer: 'NO',
                isPasswordHide: true,
            }
        },
        created: function () {

        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.isNonVVGDealer = process.env.NON_VVG_DEALER;
            self.checkLocalStorage();
        },
        methods: {
            login: function() {

                var error = false;
                self.username_error_msg = '';
                self.password_error_msg = '';

                if(!self.username || self.username == null || self.username == "") {
                    self.username_error_msg = "The username field is required.";
                    error = true;
                }

                if(!self.password || self.password == null || self.password == "") {
                    self.password_error_msg = "The password field is required.";
                    error = true;
                }

                if(!error) {

                    self.buttonNames.loginButton = "Login...";
                    self.disableButtons.loginButton = true;
                    /*$('#loginbtn').text("Login...");
                    $("#loginbtn").attr("disabled", true);*/

                    var fields = {
                        email: self.username,
                        password: self.password
                    };

                    HTTP.post("login", fields)
                        .then(function (data) {

                            self.buttonNames.loginButton = "Login";
                            self.disableButtons.loginButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/

                            if (data.status == 200) {
                                localStorage.setItem("api_token", data.data.content.api_token);
                                localStorage.setItem("access_token", data.data.content.access_token);
                                localStorage.setItem("user_obj", JSON.stringify(data.data.user_obj));
                                window.location.href = "/dashboard";
                            }
                        })
                        .catch(function (error) {
                            self.error_msg_login = "";
                            self.buttonNames.loginButton = "Login";
                            self.disableButtons.loginButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/
                            if (error.response.status == 0) {
                                self.error_msg_login = "Remote server can not be reachable";
                            }else if (error.response.status == 422) {
                                console.log(error.response);
                                self.username_error_msg = error.response.data.email[0];
                                self.password_error_msg = error.response.data.password[0];
                            } else {
                                if (error.response.data.message) {
                                    self.error_msg_login = error.response.data.message;
                                }
                            }
                        })

                }
            },
            checkLocalStorage : function () {
                if(localStorage.getItem('user_obj')) {

                    var userObj = localStorage.getItem('user_obj');
                    if (userObj != null && userObj !== "") {

                        self.$router.push('/dashboard');
                        // self.showHeader = true;
                        // alert("Hello");
                    } else {
                        self.$router.push('/');
                    }
                } else {
                    self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href;
                    self.not_registered_url = process.env.NOT_REGISTERED_HR_URL + "?identify=" + window.location.href;
                    $('#main-header').hide();
                    $('#sidebar-wrapper').hide();
                    $("#wrapper").addClass("login-div-full");

                    $(".loginbg").show();
                }
            },
            hideShowPassword: function() {
                self.isPasswordHide = !self.isPasswordHide;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Login/Login.vue